import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

// The longer version of what the chat is for, with examples: the page itself
// keeps its words short and opens this for the rest. In the chat an example is
// a button that puts it in the message box (`onPick`); elsewhere it is text.
export const SECTIONS = [
  {
    title: "Log what you ate",
    body: "Say it the way you would to a friend. Each food becomes an entry with its calories and macros, at the meal you name or the one the time of day suggests.",
    examples: ["two eggs and toast for breakfast", "a latte and a croissant", "chicken salad for lunch"],
  },
  {
    title: "Fix the log",
    body: "Change or take out something already logged today. \"That\" means what the last reply logged.",
    examples: ["make that lunch", "it was 50 g, not 30 g", "remove the toast"],
  },
  {
    title: "Keep the cupboard",
    body: "Tell it what you have in. What matters is that you have it, not how much. It comes off when you say it's gone.",
    examples: ["I have eggs, greek yogurt, ribeye and tortillas", "I bought rice", "we're out of milk"],
  },
  {
    title: "Ask what to eat",
    body: "Suggestions come from your cupboard and what is left of today's target.",
    examples: ["what should I have for dinner?", "I have eggs and nuts, what do you recommend?", "how many calories do I have left?"],
  },
];

export const HelpDialog = ({ isOpen, toggle, onPick }) => (
  <Modal isOpen={isOpen} toggle={toggle} scrollable data-testid={"chat-help"}>
    <ModalHeader toggle={toggle}>What the chat does</ModalHeader>
    <ModalBody>
      {SECTIONS.map((section) => (
        <div key={section.title} className="mb-3">
          <h6 className="mb-1">{section.title}</h6>
          <p className="small text-muted mb-1">{section.body}</p>
          <div className="noshchat-help__examples">
            {section.examples.map((example) =>
              onPick ? (
                <Button
                  key={example}
                  color={"light"}
                  size={"sm"}
                  className="mr-1 mb-1 text-left"
                  onClick={() => {
                    onPick(example);
                    toggle();
                  }}
                  data-testid={"chat-help-example"}
                >
                  “{example}”
                </Button>
              ) : (
                <span key={example} className="badge badge-light mr-1 mb-1">“{example}”</span>
              )
            )}
          </div>
        </div>
      ))}
      <p className="small text-muted mb-0">
        Each reply ends with a line on where your day stands against your target. A <b>+1</b> or <b>−1</b> beside
        a tab shows for 15 seconds after a message changes it.
      </p>
    </ModalBody>
    <ModalFooter>
      <Button color={"secondary"} size={"sm"} onClick={toggle}>
        Close
      </Button>
    </ModalFooter>
  </Modal>
);

// The small "?" that opens it.
export const HelpButton = ({ onClick, className = "", label = "How it works" }) => (
  <Button color={"link"} size={"sm"} className={`p-0 ${className}`} onClick={onClick} data-testid={"chat-help-open"}>
    <i className="fa fa-question-circle" /> {label}
  </Button>
);
